import doc                    from '@widesk-core/decorators/doc';
import model                  from '@widesk-core/decorators/model';
import TimestampAble          from '@widesk-core/models/traits/TimestampAble';
import Blamable               from '@/models/traits/Blamable';
import FondationsServiceModel from '@/models/FondationsServiceModel';
import Translatable           from '@widesk-core/models/traits/Translatable';
import ShowModel              from '@models/fondations/ShowModel';
import isSameOrBefore         from 'dayjs/plugin/isSameOrBefore';
import dayjs                  from 'dayjs';

dayjs.extend(isSameOrBefore);

@model.cacheDuration()
@model.urnResource('entertainment')
@doc.path('/entertainments/{?id}')
export default class FondationsEntertainmentModel extends Blamable(TimestampAble(Translatable(FondationsServiceModel, {
	'title': true,
}))) {
	private declare _tsFilters: {
		'dateEnd[after]': string | Date;
		'dateEnd[before]': string | Date;
		'dateEnd[strictly_after]': string | Date;
		'dateEnd[strictly_before]': string | Date;
		'dateStart[after]': string | Date;
		'dateStart[before]': string | Date;
		'dateStart[strictly_after]': string | Date;
		'dateStart[strictly_before]': string | Date;
		'enabled': boolean;
		'id': id;
		'reference': string;
		'show': id;
		'translations.title': string;
	};

	private declare _tsSorts: {
		'dateStart': string;
		'dateEnd': string;
		'edition': string;
	};

	@doc.model(ShowModel) declare show: ShowModel;
	@doc.date declare dateEnd: Dayjs;
	@doc.date declare dateStart: Dayjs;
	@doc.string declare address: string;
	@doc.string declare reference: string;
	@doc.string declare edition: string;

	getDays() {
		const days = [];
		let current = this.dateStart;

		while (current.isSameOrBefore(this.dateEnd)) {
			days.push(current);
			current = current.add(1, 'day');
		}

		return days;
	}
}
